export default __webpack_public_path__ + "static/media/fillTick.6905c018.svg";